<template>
  <section class="section-base form-section-base">
    <div class="form-section-base__title mb-4">
      Регистрационный номер распоряжения об отмене доверенности
    </div>
    <v-container>
      <div class="form-base">
        <v-text-field
          label="Регистрационный номер"
          outlined
          v-model="$v.orderNumber.$model"
          :errorMessages="getValidationErrorText($v.orderNumber)"
          v-mask="['####-##########']"
        />
      </div>

      <Footer
        @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
        @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import { minLength, required } from 'vuelidate/lib/validators';

import { Role } from '@/utils/dictionaries';
import { leaveStep, checkInvalid } from '@/utils/services';
import Footer from '@/components/services/elements/Footer';
import { StepDirection, StepName } from '@/types/services';
import { ServicesModule } from '@/store/modules/services';
import { getValidationErrorText } from '@/utils/validate';
import { ExtractionRodStep } from '@/constants';

export default {
  name: 'ProxyInfo',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Footer,
  },
  data() {
    return {
      getValidationErrorText,
      StepDirection,
      StepName,
      leaveStep,
      Role,
      invalidFields: [],
      orderNumber: '',
    };
  },
  validations() {
    return {
      orderNumber: {
        required,
        minLength: minLength(15),
      },
    };
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      const extractionRodDetails =
        ServicesModule.statement.extractionRodDetails;

      if (extractionRodDetails) {
        this.orderNumber = extractionRodDetails.orderNumber;
      }
    },

    assemblyModel() {
      return {
        extractionRodDetails: {
          orderNumber: this.orderNumber,
        },
      };
    },

    touchFields() {
      this.invalidFields = [];

      this.$v.$touch();
      checkInvalid(this.$v, this.invalidFields);
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: ExtractionRodStep.PROXY_INFO,
      });
    },
  },
};
</script>
